// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3B2S_","bigColWidth":"Table_bigColWidth__3lQch","biggerColWidth":"Table_biggerColWidth__18W-l","row":"Table_row__MkKI7","col":"Table_col__39P7M"};